import globalTheme from '../global'

const TablePagination = {
	MuiTablePagination: {
		styleOverrides: {
			root: {
				color: globalTheme.palette.primary.main,
				'&:last-child': {
					borderBottom: 0,
					padding: globalTheme.spacing(3, 0, 0),
				},
			},
		},
	},
}

export default TablePagination
